import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import DefaultLayout from "../../layout/DefaultLayout";

const PrivateRoutes = () => {
  const { userID } = useAuth();

  return userID ? (
    <DefaultLayout>
      <Outlet />
    </DefaultLayout>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoutes;
